import * as $$ from "jquery-selector-cache";
import * as mapboxgl from "mapbox-gl";
import {LngLatLike, Map} from "mapbox-gl";

// Module variable
let map: Map;
let marker: mapboxgl.Marker;

interface OptionsMapType {
    lngLat: LngLatLike;
}

/**
 * Initialize the popin map
 */
function initPopinMap(options?: OptionsMapType) {
    if (!$$(".cpt-popin-map").length && map) {
        return;
    }

    createMap(options);
    if (options && !marker) {
        marker = addMarker(map, options.lngLat);
    }
}

/**
 * Create the map
 */
function createMap(options?: OptionsMapType) {
    // Exit when the map is already initialized
    if (map) {
        return;
    }
    const {lngLat} = options;
    (mapboxgl as any).accessToken = "pk.eyJ1IjoibGFzdG1pbnV0ZSIsImEiOiJjanNieHZ2M2IwZmsxNDRzMjFyaGhoZGphIn0.OyyFa67nXT8ItjRMbAz4Jg";
    map = new mapboxgl.Map({
        container: "map_container",
        style: "mapbox://styles/mapbox/streets-v11",
        zoom: 9,
        center: lngLat,
    });
}

/**
 * Add marker on map
 * @param mapInstance
 * @param lngLat
 */
function addMarker(mapInstance: Map, lngLat: LngLatLike) {
    return new mapboxgl.Marker({ color: "#f2007d" })
        .setLngLat(lngLat)
        .addTo(mapInstance);
}

/**
 * Open the popin map
 * @param options
 */
function openPopinMap(options?: OptionsMapType) {
    $$(".popin-map-content").removeClass("d-none");
    initPopinMap(options);
}

export {
    initPopinMap,
    openPopinMap,
};
